module.exports = __webpack_public_path__ + "static/media/listing-page-goa.3e5ac06a.jpg";